var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXsg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32847)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#D21E2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.07875 3.29344V1.6875L15.0559 5.13675L13.6738 5.94L9.07875 3.29344ZM13.7655 11.403V6.111L15.1611 5.30775V12.2063L13.7655 11.403ZM9.07875 14.2206L13.6738 11.5746L15.0559 12.3772L9.07875 15.8265V14.2206ZM2.90475 12.3772L4.29975 11.5746L8.88131 14.2206V15.8265L2.90475 12.3772ZM2.8125 5.30775L4.19456 6.111V11.403L2.8125 12.2063V5.30775ZM2.90475 5.13675L8.88131 1.6875V3.29344L4.30031 5.94L2.90475 5.13675ZM8.99325 3.44475L4.38581 6.09188V11.4103L8.99325 14.0698L13.5878 11.4103V6.09188L8.99325 3.44475ZM12.6928 8.19788L12.4954 8.53988L11.1791 7.803L9.49388 8.75025L11.1786 9.69806L12.4948 8.96119L12.6928 9.30319L11.5869 9.92194L12.6928 10.5407L12.4954 10.8832L11.3895 10.2645V11.502H10.9811V10.0406L9.29644 9.09281V10.9884L10.5998 11.7124L10.4023 12.0482L9.29644 11.4294V12.6669H8.8875V11.4294L7.78162 12.0482L7.57125 11.7062L8.8875 10.9817V9.09281L7.20225 10.0406V11.502H6.78094V10.2645L5.68856 10.8832L5.47762 10.5407L6.5835 9.92194L5.47762 9.30319L5.68856 8.96119L6.99188 9.69806L8.69006 8.75025L6.99131 7.80244L5.68856 8.53931L5.47762 8.19731L6.5835 7.57856L5.47762 6.95981L5.68856 6.61781L6.78094 7.23656V5.99231H7.20281V7.45369L8.8875 8.4015V6.51263L7.58419 5.78813L7.78162 5.44613L8.8875 6.06487V4.82737H9.29587V6.06487L10.4018 5.44613L10.5986 5.78813L9.29587 6.51263V8.40825L10.9806 7.46044V5.99231H11.3889V7.22981L12.4948 6.61106L12.6917 6.95363L11.5864 7.57237L12.6922 8.19731L12.6928 8.19788Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32847"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXsg);
export default __webpack_public_path__ + "static/media/xsg.9e4fc494c67d89cba652634317009f22.svg";
export { ForwardRef as ReactComponent };